<template>
  <div>
    <router-link :to="{name: 'Create Employee'}" class="button is-small is-info">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>&nbsp; Create new</router-link>
    &nbsp;
    <button class="button is-small" @click="refreshTable()">Refresh</button>
    <div style="clear:both"></div>
        <br />
    <b-select size="is-small" v-model="perPage">
        <option value="5">5 per page</option>
        <option value="10">10 per page</option>
        <option value="15">15 per page</option>
        <option value="20">20 per page</option>
        <option value="100">100 per page</option>
        <option value="200">200 per page</option>
        <option value="300">300 per page</option>
        <option value="1000">1000 per page</option>
      </b-select>
    <table-pagination :tableData="employees.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="employees.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column field="employeeIdNumber" class="table-column-content-is-small" label="Employee ID #" sortable>
          {{item.row.employeeIdNumber}}
        </b-table-column>
        <b-table-column field="branchCode" class="table-column-content-is-small" label="Branch Code" sortable>
          {{item.row.branchCode}}
        </b-table-column>
        <b-table-column field="employeeIdNumber" class="table-column-content-is-small" label="Fullname" sortable>
          <span v-if="item.row.hasProfileImage">
            <img :src="`${apiHostAndPort}api/employees/profile-image/${item.row.employeeId}`" width="60" height="60" />
          </span>
          <span v-else>
            <img src="../../assets/user-6.png" width="60" height="60" />
          </span>
          &nbsp; {{item.row.fullname}}
        </b-table-column>
        <b-table-column field="employeeIdNumber" class="table-column-content-is-small" label="Total Leaves">
          {{item.row.numberOfLeaves}}
        </b-table-column>
        <b-table-column>
          <router-link :to="{name: 'Edit Employee', params: {employeeId: item.row.employeeId}}" class="button is-small is-warning">Edit</router-link>
          &nbsp;
          <router-link :to="{name: 'Job History of Employee', params: {employeeId: item.row.employeeId}}" class="button is-small is-info">Job histories</router-link>
          &nbsp;
          <router-link :to="{name: 'Document Of Employee', params: {employeeId: item.row.employeeId}}" class="button is-small is-info">Scanned docs ({{item.row.totalScannedDoc}})</router-link>
          &nbsp;
          <button class="button is-danger is-small" @click="openDeleteEmployeeModal(item.row.employeeId, item.row.fullname)">Delete</button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </table-pagination>
    <app-delete-modal/>
  </div>
</template>

<script>
import TablePagination from '../TablePagination.vue'
import Delete from '../../components/Employee/Delete.vue'
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import ApiInfo from '../../_services/apiInfo'

const apiInfo = new ApiInfo()

export default {
  data() {
    return {
      isEmpty: false,
      page: 1,
      perPage: 10,
      search: '',
      includeInactive: true,
      apiHostAndPort: ''
    }
  },
  computed: {
    ...mapState('employee', {
      isLoadingTable: state => state.isLoadingTable,
      employees: state => state.employees
    })
  },
  components: {
    tablePagination: TablePagination,
    appDeleteModal: Delete
  },
  mounted() {
    this.default()
  },
  created() {
    this.getApiHostAndPort()
  },
  methods: {
    ...mapActions('employee', ['getPaginatedEmployees', 'openDeleteModal']),
    default() {
      this.getPaginatedEmployees({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        includeInactive: this.includeInactive
      })
    },
    getApiHostAndPort() {
      apiInfo.hostAndPort().then(response=>{
        this.apiHostAndPort = response
      })
    },
    openDeleteEmployeeModal(employeeId, fullname) {
      this.openDeleteModal({
        showDeleteModal: true,
        employee: {
          employeeId,
          fullname
        }
      })
    },
    refreshTable() {
      this.default()
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedEmployees({
        page: this.page,
        pageSize: val,
        query: this.search,
        includeInactive: this.includeInactive
      })
    },
    page(val) {
      this.getPaginatedEmployees({
        page: val,
        pageSize: this.perPage,
        query: this.search,
        includeInactive: this.includeInactive
      })
    },
    search(val) {
      this.getPaginatedEmployees({
        page: this.page,
        pageSize: this.perPage,
        query: val,
        includeInactive: this.includeInactive
      })
    }
  }
}
</script>
